import { clsx, type ClassValue } from "clsx";
import { StaticImport } from "next/dist/shared/lib/get-img-props";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const dateFormatter = new Intl.DateTimeFormat("it-IT", {
  day: "2-digit",
  month: "2-digit",
  year: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
});

export const hourFormatter = new Intl.DateTimeFormat("it-IT", {
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
});

export const priceFormatter = new Intl.NumberFormat("it-IT", {
  style: "currency",
  currency: "EUR",
});

export const jldDayConverter = (day: string) => {
  return String(day).charAt(0).toUpperCase() + String(day).charAt(1);
};

export const isMobile = (userAgent: string) => {
  return /iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(
    userAgent.toLowerCase()
  );
};

export type ImageWithAlt = {
  src: string | StaticImport;
  alt: string;
};
